import { IImporterReject } from 'library/ts/interfaces/importer/IImporterReject';
import { IPlayerAdapterEventVO } from 'library/ts/player/adapter/interfaces/events/IPlayerAdapterEventVO';
import { IResourceConfig } from 'library/ts/player/adapter/interfaces/resource/config/IResourceConfig';
import { IPlayerAdapterAPI } from 'library/ts/player/adapter/IPlayerAdapterAPI';
import { IHDCPSupport } from 'library/ts/utilities/modules/HDCP';
import { IFatalTagError } from 'tag/ts/tag/interfaces/events/IFatalTagError';
import { ITagEventDataPromiseReject } from 'tag/ts/tag/interfaces/events/ITagEventDataPromiseReject';
import { ITagEventDataPromiseResolve } from 'tag/ts/tag/interfaces/events/ITagEventDataPromiseResolve';
import { ITagEventDataVO } from 'tag/ts/tag/interfaces/events/ITagEventDataVO';
import { IResizeObserverEntry } from 'tag/ts/tag/interfaces/IResizeObserverEntry';
import { IParamsVO } from 'tag/ts/tag/interfaces/params/IParamsVO';
import { IPlayerEventVO } from 'tag/ts/tag/interfaces/vtg/player/IPlayerEventVO';
import { TTagEventCallback } from 'tag/ts/tag/types/TTagEventCallback';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description TagEvent data VO
 */
export class TagEventDataVO implements ITagEventDataVO {

	// Smart Tag parameters
	paramsVO?: IParamsVO;

	// ResizeObserver event
	resize?: IResizeObserverEntry;

	// Online / Offline status of ConnectionManager
	online?: boolean;

	// HTML element container for VTG player to create player instance in
	playerContainer?: HTMLElement;

	// resource config object
	resourceConfig?: IResourceConfig;

	// fatal error object
	fatalError?: IFatalTagError;

	// tracks number of player instances we've created for video playback
	playerNumber?: number;

	// instance of adapted player (i.e. avia)
	adaptedPlayerInstance?: Record<string, any>;

	// extension of original adapted player event (i.e. avia)
	adaptedPlayerEvent?: IPlayerEventVO;

	// instance of player API implementation provided by player adapter
	player?: IPlayerAdapterAPI;

	// player event object dispatched by player adapter
	playerAdapterEvent?: IPlayerAdapterEventVO;

	// IMPORTANT: Smart Tag player adapter event object for external consumption
	playerEvent?: IPlayerAdapterEventVO;

	// event callback we may want to call after receiving the event
	eventCallback?: TTagEventCallback;

	// Delay execution of action on dispatched event in milliseconds
	executionDelay?: number;

	// latest version of HDCP supported
	latestHDCPSupported?: IHDCPSupport;

	// promise resolve method
	promiseResolve?: ITagEventDataPromiseResolve;

	// promise reject method
	promiseReject?: ITagEventDataPromiseReject;

	// importer reject payload
	importerError?: IImporterReject;

	// Nerd Mode diagnostic overlay visibility state (true = visible, false = hidden)
	nerdModeVisible?: boolean;

	// Nerd Mode verbose mode state (true = enabled, false = disabled)
	nerdModeVerbose?: boolean;

	// Nerd Mode capture-ready signal payload: whether capture already auto-started (URL/config)
	nerdModeCapturing?: boolean;

	// Nerd Mode "expand all JSON nodes" state (true = all tree nodes fully expanded)
	nerdModeExpandAll?: boolean;

	// Nerd Mode attached/detached (viewport-pinned) positioning state (true = detached)
	nerdModeDetached?: boolean;

	// Label of the host-injected container tab that was activated/deactivated
	// (ON_NERD_MODE_CONTAINER_TAB_ACTIVATED / ON_NERD_MODE_CONTAINER_TAB_DEACTIVATED)
	nerdModeContainerTabLabel?: string;

}